import type { TextChain } from '@/api/types/stowed-element'

/** Stable reference for an absent `linkedTextChains` — a module-level constant rather than a fresh
 *  `[]` per render (the same reasoning as `EMPTY_SELECTED_TEXT_BOX_IDS` in
 *  `use-selection-history`): it is passed straight into `ShapeManager`, which re-renders on prop
 *  identity. */
export const EMPTY_TEXT_CHAINS: TextChain[] = []
